<ng-container *ngIf="paymentRequestLoading || loading">
  <p-progressSpinner [style]="{width: '32px', height: '32px', margin: '42px auto', display: 'block'}" styleClass="custom-spinner" strokeWidth="4"></p-progressSpinner>
</ng-container>
<ng-container *ngIf="!paymentRequestLoading && !loading">
  <ng-container *ngIf="paymentRequestFailed">
    <p class="error">{{'ui.payment_request_form.error'| translate}}</p>
  </ng-container>
  <ng-container *ngIf="!paymentRequestFailed">
    <div class="payment-link-form-wrap">
      <ng-container *ngIf="device != 'mobile' || previewOpen == false">
        <div class="payment-link-form">
          <ng-container *ngIf="errors.length > 0">
            <div class="errors">
              <ng-container *ngFor="let error of errors">
                <div class="form-error">{{ error.key | translate: error.params }}</div>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="sites && sites.length > 1">
            <div class="input-row">
              <div class="label">
                {{'ui.payment_request_form.transaction_site'| translate}}
              </div>
              <div class="input-holder full-width">
                <select class="primary" [(ngModel)]="paymentSite" (ngModelChange)="paymentSiteChanged()">
                  <option value="0">{{'ui.payment_request_form.please_select'| translate}}</option>
                  <ng-container *ngFor="let site of sites">
                    <option value="{{ site.id }}">{{ site.name }}</option>
                  </ng-container>
                </select>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="showOptionalMessage">
            <div class="input-row">
              <div class="label">
                {{'ui.payment_request_form.optional_message'| translate}}
              </div>
              <div class="input-holder full-width">
                <textarea #paymentOptionalMessageField pInputTextarea [class.invalid]="optionalMessageTooLong"
                  [formControl]="paymentMessage" [rows]="2" [autoResize]="true" (keyup)="buildPaymentMessage()"
                  (onResize)="optionalTextareaResize($event)">
                                              </textarea>
              </div>
              <div class="under-optional-message">
                <div>
                  <ng-container *ngIf="templates.length > 0">
                    <div class="use-template-link" (click)="selectTemplate()">{{'ui.payment_request_form.use_template'| translate}}</div>
                  </ng-container>
                </div>
                <div class="character-count" [class.invalid]="optionalMessageTooLong">{{ remainingOptionalMessageLength }}</div>
              </div>
            </div>
          </ng-container>
          <div class="input-row">
            <div class="label">
              {{'ui.payment_request_form.description'| translate}}
            </div>
            <div class="input-holder full-width">
              <textarea #paymentDescriptionField pInputTextarea [class.invalid]="paymentDescriptionTooLong" [rows]="1"
                [autoResize]="true" [formControl]="paymentDescription" [placeholder]="'ui.payment_request_form.show_on_record'| translate"
                (keyup)="buildPaymentMessage()" (onResize)="descriptionTextareaResize($event)"></textarea>
            </div>
            <div class="under-payment-description">
              <div class="character-count" [class.invalid]="paymentDescriptionTooLong">{{ remainingPaymentDescriptionLength }}</div>
            </div>
          </div>
          <ng-container *ngIf="reconcilePaymentsAgainstInvoice">
            <div class="input-row">
              <div class="label">Select Invoice:</div>
              <div class="invoice-select-area" (click)="toggleDropdown()">
                <div class="selected-item" [innerHTML]="selectedInvoice ? (selectedInvoice | getInvoiceLabel: practiceCurrency : true) : 'Select Invoice'">
                </div>
                <div class="dropdown-arrow" >
                  <ng-container *ngIf="!selectedInvoice">&#9660;</ng-container>
                  <ng-container *ngIf="selectedInvoice">
                    <span class="clear-icon" (click)="clearInvoiceSelection()" title="Clear selection">&#x274C;</span>
                  </ng-container>
                </div>
              </div>
              <div class="dropdown" *ngIf="dropdownOpen">
                <div class="dropdown-header">
                  <input
                    type="text"
                    placeholder="Search invoices..."
                    [(ngModel)]="invoiceSearch"
                    (input)="filterInvoices()"
                    (click)="dropdownOpen = true"
                  />
                </div>
                <ul class="dropdown-list">
                  <li *ngIf="!filteredInvoices || filteredInvoices.length === 0" class="dropdown-item no-selection">
                    No invoices available to select
                  </li>
                  <li
                    *ngFor="let invoice of filteredInvoices"
                    (click)="selectInvoice(invoice)"
                    class="dropdown-item"
                  >
                     <span [innerHTML]="invoice | getInvoiceLabel: practiceCurrency"></span>
                  </li>
                </ul>
              </div>

            </div>
          </ng-container>
          <ng-container *ngIf="(outstanding | parseInt) > 0 && balanceEnabled && !selectedInvoice">
            <div class="input-row single-line">
              <div>
                <label class="label"><span class="label-red">{{'ui.payment_request_form.account_is'| translate: {balance: (outstanding | clientBalance : practiceCurrency?.currencyCode : practiceCurrency?.currencySymbol)} }}</span>  <br /> <ng-container *ngIf="canShowRequestFullAmount(reconcilePaymentsAgainstInvoiceSelected)">{{'ui.payment_request_form.request_full_amount'| translate}}</ng-container></label>
              </div>
              <ng-container *ngIf="canShowRequestFullAmount(reconcilePaymentsAgainstInvoiceSelected)">
                <div class="checkbox-holder">
                  <p-checkbox [(ngModel)]="requestFullAmount" (onChange)="buildPaymentMessage()" name="selected" [binary]="true"></p-checkbox>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="!requestFullAmount">
            <div class="input-row single-line">
              <span class="label">{{'ui.payment_request_form.amount_requested'| translate}}</span>
              <div class="input-holder amount">
                <span class="pound">{{ practiceCurrency?.currencySymbol || '£' }}</span>
                <input pInputText class="amount-input" (keydown)="preventNonNumericChars($event)" (keyup)="$event.key == 'Enter' ? submitPaymentRequest(): buildPaymentMessage()" [(ngModel)]="paymentValue" placeholder="0.00" [style]="{width: '100%'}" [class.error]="paymentAmountError">
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="holdAndCaptureEnabled && showPreAuth">
            <div class="footer-payment-reminder">
              <div class="input-row single-line top-aligned">
                <div>
                  <label class="label">{{'ui.payment_request_form.pre_authorise'| translate}}</label>
                  <div class="more-info">{{'ui.payment_request_form.funds_held'| translate}}</div>
                </div>
                <p-checkbox [(ngModel)]="authOnly" (onChange)="buildPaymentMessage()" name="selected" [binary]="true"></p-checkbox>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="paymentReminderEnable">
            <div class="input-row single-line top-aligned">
              <div>
                <label class="label">{{'ui.payment_request_form.send_reminders' | translate}}</label>
              </div>
              <p-checkbox [(ngModel)]="paymentReminderEnabled" (onChange)="buildPaymentMessage()" name="selected" [binary]="true"></p-checkbox>
            </div>
          </ng-container>
          <ng-container *ngIf="customExpiryAllowed && showAdvancedOptions">
            <div class="advanced-opener" (click)="advancedOpen = !advancedOpen">
              <ng-container *ngIf="!advancedOpen">
                {{'ui.payment_request_form.advanced_settings'| translate}}
              </ng-container>
              <ng-container *ngIf="advancedOpen">
                {{'ui.payment_request_form.hide_settings'| translate}}
              </ng-container>
            </div>
            <ng-container *ngIf="advancedOpen">
              <div class="input-row">
                <div class="label">{{'ui.payment_request_form.link_expires'| translate}}</div>
                <div class="input-holder full-width">
                  <select class="primary" (change)="buildPaymentMessage()" [(ngModel)]="paymentExpiry">
                    <ng-container *ngFor="let expiryOption of expiryOptions">
                      <option value="{{ expiryOption.amount }}">{{ expiryOption.labelKey | translate : {count: expiryOption.amount} }}</option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <div class="btn-row">
            <ng-container *ngIf="device == 'mobile'">
              <div class="preview-link" (click)="togglePreview()">{{'ui.payment_request_form.preview'| translate}}</div>
            </ng-container>
            <button (click)="submitPaymentRequest()" pButton [label]="'ui.payment_request_form.send_request'| translate" [disabled]="optionalMessageTooLong || paymentDescriptionTooLong"></button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="device != 'mobile' || previewOpen == true">
        <div class="payment-link-preview">
          <div class="preview-title">
            {{'ui.payment_request_form.client_message'| translate}}

            <ng-container *ngIf="device == 'mobile'">
              <div class="preview-link" (click)="togglePreview()">{{'ui.payment_request_form.close_preview'| translate}}</div>
            </ng-container>
          </div>
          <div class="message-preview">
            <message
              [message]="messagePreview"
              [hideTimeStamp]="true"
              [fullWidth]="true"
            ></message>
          </div>
          <div class="preview-title">
            {{'ui.payment_request_form.payment_screen_preview'| translate}}
          </div>
          <payment-screen-preview
            [practice]="practice ?? undefined"
            [description]="paymentDescription.value"
            [practiceCurrency]="practiceCurrency"
            [amount]="getPaymentString()"
            [authOnly]="authOnly"
            [paymentMessage]="paymentMessage.value"
          ></payment-screen-preview>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
